import { render, staticRenderFns } from "./conversation-messages.vue?vue&type=template&id=3bb4ae4d&scoped=true"
import script from "./conversation-messages.vue?vue&type=script&lang=js"
export * from "./conversation-messages.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bb4ae4d",
  null
  
)

export default component.exports